import QuantityProduct from './QuantityProduct'

class ExclusivePhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 5
}

export default ExclusivePhotoProduct
